import { ChevronRight, MapPin, Clock, Wine } from "lucide-react";

export default function Hero() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center justify-center overflow-hidden"
    >
      <img
        src="https://customer-assets.emergentagent.com/job_wine-tasting-book/artifacts/w3avmm3s_Screenshot_1-7-2026_10944_bykevin.pic-time.com.jpeg"
        alt="Aerial view of Gledswood Homestead estate"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-[#FDFBF7]" />

      <div className="relative z-10 text-center px-6 max-w-4xl">
        <p className="animate-fade-up text-white/85 text-sm uppercase tracking-[0.3em] font-semibold mb-6">
          c.1810
        </p>
        <h1 className="animate-fade-up delay-100 font-serif text-5xl md:text-6xl lg:text-7xl font-semibold text-white leading-[1.05]">
          Taste the estate at
          <br />
          <span className="italic font-normal">Gledswood Cellar Door</span>
        </h1>
        <p className="animate-fade-up delay-200 mt-6 text-lg md:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
          Reserve a wine tasting at the convict built cellar door. Small pours,
          big conversations, and a grazing menu made for a long afternoon.
        </p>

        <div className="animate-fade-up delay-300 mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            data-testid="hero-book-btn"
            onClick={() => scrollTo("book")}
            className="group px-8 py-4 rounded-full bg-[#4A5D23] text-white font-semibold text-lg hover:bg-[#3D4D1D] transition-all hover:-translate-y-0.5 flex items-center gap-2"
          >
            Book a Tasting
            <ChevronRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            data-testid="hero-menu-btn"
            onClick={() => scrollTo("menu")}
            className="px-8 py-4 rounded-full border border-white/40 text-white font-semibold text-lg hover:bg-white/10 transition-all"
          >
            View the Bar Menu
          </button>
        </div>

        <div className="animate-fade-up delay-300 mt-5 flex justify-center">
          <button
            data-testid="hero-winebar-btn"
            onClick={() => scrollTo("dine")}
            className="group inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#722F37] text-white font-semibold hover:bg-[#5E262D] transition-all hover:-translate-y-0.5"
          >
            <Wine className="h-5 w-5" />
            Book the Friday Night Wine Bar
            <span className="hidden sm:inline text-white/70 font-normal">· 6pm–11pm</span>
            <ChevronRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>

        <div className="animate-fade-up delay-400 mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-white/85 text-sm">
          <span className="flex items-center gap-2">
            <Clock className="h-4 w-4" /> Thu–Sat 11am–2pm · 1st Sun of month
          </span>
          <span className="flex items-center gap-2">
            <MapPin className="h-4 w-4" /> Camden Valley Estate
          </span>
        </div>
      </div>
    </section>
  );
}
